import script from "./TicketsCompteView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsCompteView.vue?vue&type=script&setup=true&lang=js"

import "./TicketsCompteView.vue?vue&type=style&index=0&id=11afbe54&lang=css"

const __exports__ = script;

export default __exports__